import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Grid, IconButton, InputAdornment, Typography } from "@mui/material";

import pages from "../../../constants/pages";
import { Label, TextField } from "../../../components";
import { PrimaryLoadingButton } from "../../css components/Button";

export default function FormDisplay({ formikProps }) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const uiDetails = useSelector((state) => state.renderUIDetails);

  return (
    <Grid container spacing={6}>
      <Grid item xs={12} textAlign={"center"}>
        <img style={{ height: "50px" }} src={uiDetails.siteLogo} alt="logo" />
        <Typography className="font">Please sign-in to your account</Typography>
      </Grid>

      <Grid item xs={12} style={{ paddingTop: "0px" }}>
        <Label
          formikProps={formikProps}
          required={true}
          name="email"
          title="Email Address"
        />

        <TextField
          required
          formikProps={formikProps}
          name="email"
          placeholder="Email address"
          autoComplete="off"
        />
      </Grid>

      <Grid item xs={12} style={{ paddingTop: "0px" }}>
        <Label
          formikProps={formikProps}
          required={true}
          name="password"
          title="Password"
        />

        <TextField
          required
          autoComplete="off"
          type={showPassword ? "text" : "password"}
          name="password"
          formikProps={formikProps}
          placeholder="Password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {!showPassword && <VisibilityOffIcon />}
                  {showPassword && <VisibilityIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={6} />

      {/* <Grid item xs={6} textAlign={"end"}>
        <Typography variant="button">
          <Typography
            variant="button"
            className="purple font"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(pages.resetEmailPasswordPage.route)}
          >
            Forgot Password?
          </Typography>
        </Typography>
      </Grid> */}

      <Grid item xs={12}>
        <PrimaryLoadingButton
          fullWidth={true}
          type="submit"
          variant="contained"
          onClick={formikProps.handleSubmit}
          disabled={!formikProps.dirty || !formikProps.isValid}
          loading={formikProps.isSubmitting}
        >
          Log In
        </PrimaryLoadingButton>
      </Grid>

      {/* <Grid item xs={12} alignSelf="center" textAlign={"center"}>
        <Typography className="font" variant="button">
          New on our platform? &nbsp;
          <Typography
            variant="button"
            className="purple font"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/sign-up")}
          >
            Create an account
          </Typography>
        </Typography>

        <br />
      </Grid> */}
    </Grid>
  );
}
